export default [
  {
    id: 'lazada-product',
    name: 'Lazada x100',
    plan: 'lazada',
    title: 'Lazada x100',
    subTitle: '',
    price: 100000,
    beforePrice: 0,
    totalMonths: 0,
    description: ['Sao chép 100 sản phẩm từ Shopee sang Lazada'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/lazada.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'lazada-product-300',
    name: 'Lazada x300',
    plan: 'lazada',
    title: 'Lazada x300',
    subTitle: '',
    price: 200000,
    beforePrice: 300000,
    totalMonths: 0,
    description: ['Sao chép 300 sản phẩm từ Shopee sang Lazada'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/lazada.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'lazada-product-1000',
    name: 'Lazada x1000',
    plan: 'lazada',
    title: 'Lazada x1000',
    subTitle: '',
    price: 500000,
    beforePrice: 1000000,
    totalMonths: 0,
    description: ['Sao chép 1000 sản phẩm từ Shopee sang Lazada'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/lazada.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'lazada-product-3000',
    name: 'Lazada x3000',
    plan: 'lazada',
    title: 'Lazada x3000',
    subTitle: '',
    price: 1000000,
    beforePrice: 3000000,
    totalMonths: 0,
    description: ['Sao chép 3000 sản phẩm từ Shopee sang Lazada'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/lazada.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];
